<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
          <cardHead :title="'Customer Provider Logs'"></cardHead>
          <list></list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from "./list.vue";
export default {
  name: "CustomerProviderLogs",
  components: { list },
};
</script>
